export default __webpack_public_path__ + "static/media/CommonInternetWhalingAttacks4.fad4d308.jpg";